import requestBuilder from '@/requestBuilder'
import paramsBuilder from '@/paramsBuilder'

const apiRecent = {
  getRecentFiles (params) {
    return requestBuilder.get({ path: `/items/recent`, params: paramsBuilder(params) })
  }
}

export default apiRecent
